export default __webpack_public_path__ + "static/media/SpaceMono-BoldItalic.946474e4.ttf";